<template>
  <ContentDetailWrap @back="$router.back()">
    <div>
      <div class="gap">
        <DetailTitle title="基本信息">
          <template #right>
            <span>采摘批次：</span>
            <span>{{ formData.pickingBatchBizNo }}</span>
          </template>
        </DetailTitle>
        
        <div class="location">
          果园定位：<span class="value">{{ formData.geoPosDetails || '-' }}</span>
        </div>
        <TablePublic :showIndex="false" :colLists="pickColLists" :tableData="[formData]" :paginationFlag="false">
        </TablePublic>
      </div>
  
      <div class="gap">
        <DetailTitle title="派发任务信息" />
  
        <TablePublic :showIndex="false" :colLists="assignColLists" :tableData="[formData]" :paginationFlag="false">
        </TablePublic>
      </div>

      <div class="gap" v-if="formData.status && formData.status !== 6">
        <DetailTitle title="任务进度" />

        <TaskProcess :formData="formData" />
      </div>
  
      <div class="gap" v-if="formData.status && formData.status === 6">
        <DetailTitle title="任务取消原因" />
        
        <div style="width: 70%; font-size: 14px">{{ formData.cancelReason || '-' }}</div>
      </div>
  
      <div class="gap">
        <div class="hbwtween" style="width: 70%; font-size: 14px">
          <div>派发人：{{ formData.distributeName }}</div>
          <div>派发时间：{{ parseTime(formData.createTime, '{y}-{m}-{d} {h}:{i}') }}</div>
        </div>
      </div>
      
    </div>
  </ContentDetailWrap>
</template>

<script>
import TablePublic from '@/components/tablePublic.vue'
import ContentDetailWrap from '@/components/ContentDetailWrap.vue'
import TaskProcess from './components/TaskProcess'
import DetailTitle from '@/components/DetailTitle.vue'

import { getPickTask } from '@/api/manage/picking-batch-task'
import { dictDataList } from '@/api/system/dict'
export default {
  name: 'TaskPickDetail',
  components: {
    TablePublic,
    ContentDetailWrap,
    TaskProcess,
    DetailTitle,
  },
  data() {
    const _this = this
    return {
      pickColLists: [
        {
          prop: 'plantationBizNo',
          label: '果园编号',
          isTrue: true,
        },
        {
          prop: 'plantationName',
          label: '果园名称',
          isTrue: true,
        },
        {
          prop: 'locDetails',
          label: '果园区域',
          isTrue: true,
          formatter(row) {
            return row.locDetails?.split(',').slice(3).join('')
          },
        },
        {
          prop: 'cultivationMethodSpecValueKey',
          label: '培育方式',
          isTrue: true,
        },
        {
          prop: 'cropAgeValue',
          label: '果树树龄（年）',
          isTrue: true,
        },
        {
          prop: 'ripenessLevelSpecAttrValueKey',
          label: '成熟度',
          isTrue: true,
        },
        {
          prop: 'planToPickTotalQuantity',
          label: '计划采摘总筐数',
          isTrue: true,
        },
        {
          prop: 'plannedNetWeightPerUnit',
          label: '计划单筐净重（斤）',
          isTrue: true,
        },
        {
          prop: 'planToPickTotalNetWeight',
          label: '计划采摘总净重（斤）',
          isTrue: true,
        },
        {
          prop: 'processFactoryName',
          label: '加工厂',
          isTrue: true,
        },
        {
          prop: 'fertilizerTypeKey',
          label: '施肥种类',
          isTrue: true,
        },
        {
          prop: 'fieldTypeKeyList',
          label: '土地性质',
          isTrue: true,
          formatter(row) {
            return row.fieldTypeKeyList
              ?.split(',')
              .map((item) => {
                const obj = {
                  1: '山地',
                  2: '水田',
                }
                return obj[item]
              })
              .join(',')
          },
        },
        {
          prop: 'ownerName',
          label: '园主/场长',
          isTrue: true,
        },
        {
          prop: 'ownerContact',
          label: '联系方式',
          isTrue: true,
        },
      ],
      assignColLists: [
        {
          prop: 'pickingDateTime',
          label: '采摘日期',
          isTrue: true,
          formatter(row) {
            return _this.parseTime(row.pickingDateTime, '{y}-{m}-{d}')
          },
        },
        {
          prop: 'supervisorIdList',
          label: '监园人员',
          isTrue: true,
          formatter(row) {
            return JSON.parse(row.supervisorIdList || '[]')
              .map((item) => item.userName)
              .join(',')
          },
        },
        {
          prop: 'remark',
          label: '备注',
          isTrue: true,
        },
      ],
      formData: { attachments: [] },
    }
  },
  mounted() {
    this.getDetail()
  },
  methods: {
    async getDetail() {
      let fertilizerTypeList = []
      try {
        await dictDataList({
          dictType: 'fertilizerType',
        }).then((res) => {
          fertilizerTypeList = res.data
        })
      } catch (error) {
        console.log(error)
      }
      const data = await getPickTask(this.$route.query.id)
      if (data.code == 200 && data.flag) {
        this.formData = data.data
        this.formData.fertilizerTypeKey = fertilizerTypeList.find(
          (item) => item.dictValue == this.formData.fertilizerTypeKey
        )?.dictLabel
      }
    },
    
    back() {
      this.$router.replace('/taskPick')
    },
  },
}
</script>

<style scoped lang="less">
@import '~@/assets/variables.less';
@import '../../../assets/form.less';

.gap {
  margin-bottom: 30px;
}

.location {
  margin-bottom: 10px;
  font-size: 14px;
  .value {
    font-size: 14px;
    color: #cb921b;
  }
}

.hbwtween {
  display: flex;
  justify-content: space-between;
}
</style>
